import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TimelineOptionProps {
  value: string;
  label: string;
  icon: string;
  isSelected: boolean;
  onClick: () => void;
}

const TimelineOption = ({ value, label, icon, isSelected, onClick }: TimelineOptionProps) => {
  return (
    <button data-component-id="src/app/quote-request/components/TimelineOption.tsx:14:4" data-component-path="src/app/quote-request/components/TimelineOption.tsx" data-component-line="14" data-component-end-line="32" data-component-file="TimelineOption.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
      onClick={onClick}
      className={`flex-1 p-4 rounded-lg border-2 transition-all duration-300 ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-card'
          : 'border-border bg-card hover:border-primary/50'
      }`}
    >
      <div data-component-id="src/app/quote-request/components/TimelineOption.tsx:22:6" data-component-path="src/app/quote-request/components/TimelineOption.tsx" data-component-line="22" data-component-end-line="31" data-component-file="TimelineOption.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20space-y-2%22%7D" className="flex flex-col items-center space-y-2">
        <div data-component-id="src/app/quote-request/components/TimelineOption.tsx:23:8" data-component-path="src/app/quote-request/components/TimelineOption.tsx" data-component-line="23" data-component-end-line="29" data-component-file="TimelineOption.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300 ${
            isSelected ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
          }`}
        >
          <Icon data-component-id="src/app/quote-request/components/TimelineOption.tsx:28:10" data-component-path="src/app/quote-request/components/TimelineOption.tsx" data-component-line="28" data-component-end-line="28" data-component-file="TimelineOption.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={icon as any} size={20} />
        </div>
        <span data-component-id="src/app/quote-request/components/TimelineOption.tsx:30:8" data-component-path="src/app/quote-request/components/TimelineOption.tsx" data-component-line="30" data-component-end-line="30" data-component-file="TimelineOption.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20font-body%20font-medium%20text-foreground%20text-center%22%7D" className="text-sm font-body font-medium text-foreground text-center">{label}</span>
      </div>
    </button>
  );
};

export default TimelineOption;